import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpParams } from '@angular/common/http';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NewCaseService {
  getNarrative(pData: any) {
    return this.baseService.post(pData, 'api/narrative/getnarrative');
  }
  private searchEvent = new Subject<any>();
  constructor(private baseService: BaseService) { }

  public searchReport(event: any) {
    this.searchEvent.next(event);
  }


  public updateSearch() {
    return this.searchEvent.asObservable();
  }
  public GetCaseList(reportNumber: string, agencyId: string) {
    return this.baseService.post({ ReportNumber: reportNumber, AgencyId: agencyId }, 'api/GetCaseDataList');
  }

  public GetReportStatus(reportNumber: string, agencyId: string) {
    return this.baseService.post({ Reportnumber: reportNumber, AgencyID: agencyId }, 'api/GetReportStatus');
  }
  //GetReportStatus
  public GetWarrantList(reportNumber: string, agencyId: string) {
    return this.baseService.post({ ReportNumber: reportNumber, AgencyId: agencyId }, 'api/GetWarrantList');
  }

  public FindReportNumber(reportNumber: string, agencyId: string, userid: number) {
    let params = new HttpParams().set('reportnumber', reportNumber);
    params = params.append('agancyId', agencyId);
    params = params.append('userId', userid);
    return this.baseService.get('api/warrant/reportnumber', params);
  }

  public FindPersonbyXREF(xref: string) {
    let params = new HttpParams().set('xref', xref);
    return this.baseService.get('api/warrant/PersonByXREF', params);
  }

  public SaveWarrant(data: any) {
    return this.baseService.post(data, 'api/warrant');
  }

  public AddPersonToReport(data: any) {
    return this.baseService.post(data, 'api/addpersontoreport');
  }

  public SaveNarrative(data: any) {
    return this.baseService.post(data, 'api/Narrative');
  }

  public GetReason() {
    return this.baseService.get('api/Narrative');
  }

  public GetLookupByFilterId(id: number) {
    return this.baseService.get(`api/Narrative/${id}`);
  }

  public GetArrestCharges(id: number) {
    return this.baseService.get(`api/Narrative/code/${id}`);
  }

  public GetUnitList() {
    return this.baseService.get(`api/Utility/units`);
  }
  public SetFileToQueue(data: any) {
    return this.baseService.post(data, 'api/SetFileUploadQueue', 'WILD', '1');
  }

  public GetIntakIds(data: any) {
    return this.baseService.post(data, 'api/GetIntake');
  }

  public GetCaseIdaByReportId(reportId: number, userId: number) {
    let params = new HttpParams().set('reportId', reportId);
    params = params.append('userId', userId);
    return this.baseService.get('api/warrant/CaseIdsByReport', params);
  }

  /*
  [
    {"Showbtn":true,"ReportNumber":"4555665756567567","XREF":123,"FirstName":"JOHN","LastName":"HOLT","MiddleName":"EVEART","Suffix":"    ","Found":true,"AgencyId":"161","RequesterId":"1554","PersonId":94,"$$hashKey":"045"},
    {"Showbtn":false,"ReportNumber":"4555665756567567","XREF":7676599,"FirstName":"AAA","LastName":"CC","MiddleName":"BBB","Suffix":"DD","Found":false,"Edit":false,"AgencyId":"161","RequesterId":"1554","$$hashKey":"047"}]
  */

}
